<template>
  <div class="login-container">
    <el-card class="login-card">
      <h2 class="login-title">管理员登录</h2>
      <el-form
        :model="loginForm"
        @keydown.enter.prevent="handleLogin"
        ref="loginFormRef"
        label-width="80px"
      >
        <el-form-item label="用户名" prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名"
            clearable
            ref="usernameInput"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div style="display: flex; gap: 10px; align-items: center">
            <el-input
              v-model="loginForm.code"
              placeholder="请输入验证码"
              style="width: 200px"
              clearable
            ></el-input>
            <img
              :src="captchaBase"
              alt="验证码"
              style="width: 120px; height: 40px; cursor: pointer"
              @click="refreshCaptcha"
              v-if="captchaBase"
              title="点击刷新验证码"
            />
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleLogin"
            style="width: 100%"
            :loading="isLoginLoading"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "AdminLogin",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        code: "",
        captchaId: "",
      },
      // loginRules: {
      //   username: [
      //     { required: true, message: "请输入用户名", trigger: "blur" },
      //   ],
      //   password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      //   code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      // },
      captchaBase: "",
      isLoginLoading: false,
      basicAuth: {
        clientId: "yyyhao-admin",
        clientSecret: "guoyin",
      },
    };
  },
  mounted() {
    if (process.env.VUE_APP_TITLE == "样衣星球测试版") {
      document.title = "样衣星球测试版LOGIN";
    } else {
      document.title = "样衣星球LOGIN";
    }
    // 确保DOM渲染完成后再聚焦，加微延迟兼容异步渲染场景
    this.$nextTick(() => {
      if (this.$refs.usernameInput) {
        // el-input的真实输入框需要通过$el获取
        this.$refs.usernameInput.$el.querySelector("input").focus();
      }
    });
  },
  created() {
    // 进入登录页就清空Vuex登录状态
    this.$store.commit("LOGOUT");
    this.getCaptcha();
  },
  methods: {
    // 生成Basic Auth请求头
    getBasicAuthHeader() {
      const authStr = `${this.basicAuth.clientId}:${this.basicAuth.clientSecret}`;
      const base64Auth = btoa(unescape(encodeURIComponent(authStr)));
      return `Basic ${base64Auth}`;
    },

    // 获取验证码
    async getCaptcha() {
      try {
        this.loginForm.code = "";
        const res = await this.$api.Login.LoGIn.yzm();
        this.loginForm.captchaId =
          res.data.data?.captchaId || res.data.captchaId;
        this.captchaBase =
          res.data.data?.captchaBase64 || res.data.captchaBase64;
        if (!this.captchaBase) throw new Error("验证码数据为空");
      } catch (error) {
        this.$message.error("验证码获取失败，请刷新重试");
        console.error("验证码异常：", error);
        setTimeout(() => this.getCaptcha(), 3000);
      }
    },

    // 刷新验证码
    refreshCaptcha() {
      this.getCaptcha();
    },

    // 登录核心逻辑（纯Vuex存储）
    async handleLogin() {
      console.log("触发了吗");

      // 1. 表单校验
      const isValid = await this.$refs.loginFormRef.validate();
      if (!isValid) {
        this.$message.warning("请填写完整登录信息");
        return;
      }

      this.isLoginLoading = true;
      try {
        // 2. 构造请求参数
        const formData = new FormData();
        formData.append("username", this.loginForm.username);
        formData.append("password", this.loginForm.password);
        formData.append("captchaId", this.loginForm.captchaId);
        formData.append("captchaCode", this.loginForm.code);
        formData.append("grant_type", "captcha");

        // 3. 调用登录接口
        const res = await this.$api.Login.LoGIn.login(formData, {
          headers: {
            Authorization: this.getBasicAuthHeader(),
          },
        });

        // 4. 校验响应
        if (res.data.code !== "200" || !res.data.data?.access_token) {
          throw new Error(res.data.msg || "登录失败，未获取到Token");
        }

        // 5. 仅同步到Vuex（无本地存储）
        const { access_token } = res.data.data;
        await this.$store.dispatch("login", { access_token });
        // 可选：获取用户信息/权限
        await this.$store.dispatch("getUserInfo");

        // 6. 路由跳转
        const redirect = this.$route.query.redirect || "/yy2126";
        await this.$router.push(redirect);
        this.$message.success("登录成功！");
        this.refreshCaptcha();
      } catch (error) {
        let errorMsg = error.message || "登录失败";
        if (error.response) {
          const { status } = error.response;
          if (status === 302) {
            errorMsg = "Basic Auth认证失败/参数格式错误";
          } else if (status === 401) {
            errorMsg = "用户名/密码/验证码错误";
            this.refreshCaptcha();
          }
        }
        this.$message.error(errorMsg);
        console.error("登录错误详情：", error);
        this.refreshCaptcha();
      } finally {
        this.isLoginLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
}
.login-card {
  width: 400px;
  padding: 20px;
}
.login-title {
  text-align: center;
  margin-bottom: 20px;
  color: #2c3e50;
}
</style>